import { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { UIText } from '@/ui';
import { useDevicesTranslation } from '../hooks';

type DeviceIdLabelProps = {
    deviceId: string;
};

/**
 * "ID: 657867a4…", the line under a device's name.
 *
 * A component rather than a key a caller reads, because the sentence is device
 * vocabulary: the device settings page shows it too, and a page has no business
 * holding the `devices` namespace just to word one line.
 */
export function DeviceIdLabel(props: DeviceIdLabelProps): ReactElement {
    const { deviceId } = props;
    const { t } = useDevicesTranslation();

    return (
        <UIText>
            <Trans
                t={t}
                i18nKey="shared.devices.id"
                values={{ id: deviceId }}
                components={{ v: <UIText type="default2" /> }}
            />
        </UIText>
    );
}
